import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { YOTPO } from 'shop/lib/util/const';
import { ContainerQueryContext } from '../../../../util/ContainerQuery.context';

import * as Styled from './ProductReviews.styled';
import ProductPropTypes from '../../Product.propTypes';

/**
 * Wrapper for Yotpo product reviews
 */
const ProductReviews = ({ id, title, showAll }) => {
  const { styleQueryMode } = useContext(ContainerQueryContext);

  return (
    <Styled.ProductReviews $styleQueryMode={styleQueryMode}>
      {showAll ? (
        <div
          className="yotpo-widget-instance"
          data-yotpo-instance-id={YOTPO.seo_widget}
        />
      ) : (
        <div
          className="yotpo-widget-instance"
          data-yotpo-instance-id={YOTPO.review_widget}
          data-yotpo-product-id={id}
          data-yotpo-currency="USD"
          data-yotpo-name={title}
          data-yotpo-url={window.location.origin + window.location.pathname}
        />
      )}
    </Styled.ProductReviews>
  );
};

ProductReviews.propTypes = {
  /**
   * Product Shopify ID
   */
  id: PropTypes.string,
  /**
   * Product title
   */
  title: ProductPropTypes.title,
  /**
   * `true` to display product reviews across all products
   */
  showAll: PropTypes.bool
};

ProductReviews.defaultProps = {
  id: null,
  title: null,
  showAll: false
};

export default ProductReviews;
